<template>
  <div class="edit">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>学生管理</Breadcrumb-item>
        <Breadcrumb-item href="/user/userTrackList">学员跟踪记录</Breadcrumb-item>
        <Breadcrumb-item>添加跟踪记录-绑定有效时间生效失败记录</Breadcrumb-item>
      </Breadcrumb>
    </div>

    <Form ref="form" :model="formData" :rules="formRules" :label-width="90" class="form">
      <Row>
        <i-col :sm="11" :md="4">
          <Form-item label="学生ID" prop="uid">
            <Input readonly v-model.number="formData.uid"></Input>
          </Form-item>
        </i-col>
        <i-col :sm="11" :md="6">
          <Form-item label="学生姓名" prop="nickname">
            <Input readonly v-model="formData.nickname"></Input>
          </Form-item>
        </i-col>
        <i-col :sm="11" :md="6">
          <Form-item label="课程顾问" prop="adviserName">
            <Input readonly v-model="formData.adviserName"></Input>
          </Form-item>
        </i-col>
        <i-col :sm="11" :md="6">
          <Form-item label="学习导师" prop="studyAdviserName">
            <Input readonly v-model="formData.studyAdviserName"></Input>
          </Form-item>
        </i-col>
      </Row>
      <Row>
        <i-col span="20">
          <Form-item label="内容" prop="content">
            <Input type="textarea" v-model="formData.content" placeholder="开课时间生效失败原因"></Input>
          </Form-item>
        </i-col>
      </Row>
      <Row>
        <i-col :sm="11" :md="6">
          <Form-item label="下次联系日期" prop="nextHandlerTime">
            <Date-picker type="date" format="yyyy-MM-dd" @on-change="nextTimeDateChange"
              :value="formData.nextHandlerTime"></Date-picker>
          </Form-item>
        </i-col>
        <i-col :sm="11" :md="6">
          <Form-item label="下次联系人" prop="nextHandlerId">
            <Select v-model.number="formData.nextHandlerId" filterable>
              <Option v-for="item in nextHandler"
                :value="item.id" :key="item.id">{{ item.nickname }}</Option>
            </Select>
          </Form-item>
        </i-col>
        <i-col :sm="11" :md="6">
        <Form-item label="状态" prop="operateStatus">
          <Select v-model="formData.operateStatus">
            <Option value="0">未处理</Option>
            <Option value="1">已处理</Option>
          </Select>
        </Form-item>
        </i-col>
      </Row>
      <Form-item>
        <Button type="primary" @click="handleSubmit()">提交</Button>
      </Form-item>
    </Form>
  </div>
</template>
<script>
  import dates from '@/tools/date/dates.js'
  export default {
    components: {},
    data () {
      return {
        nextHandler: [],
        uidReadonly: false,
        formData: {
          uid: null,
          nickname: '',
          adviserName: '',
          studyAdviserName: '',
          content: '',
          nextHandlerTime: dates.today(),
          nextHandlerId: null,
          operateStatus: '0',
        },
        formRules: {
          uid: [
            { type: 'number', required: true, message: '学生ID不能为空', trigger: 'blur' },
          ],
          content: [
            { required: true, message: '内容不能为空', trigger: 'blur' },
            { type: 'string', max: 200, message: '内容不能超过200个字', trigger: 'blur' }
          ],
        },
      }
    },
    created () {

    },
    mounted () {
      let self = this
      let formData = this.formData
      formData.uid = this.$route.query.row.uid
      this.$http.post('/adminUser/listByCondition', {status: 1}).then(function (res) {
        self.nextHandler = res.data
      })

      this.getUserInfo()
    },
    methods: {
      nextTimeDateChange (value) {
        this.formData.nextHandlerTime = value
      },
      getUserInfo () {
        let self = this
        if (!self.formData.uid) {
          return
        }
        self.$http.post('/user/queryById', {'uid': self.formData.uid}).then(function (res) {
          if (!res || !res.data) {
            return
          }
          let user = res.data
          self.formData.nickname = user.nickname
          self.formData.adviserName = user.adviserName
          self.formData.studyAdviserName = user.studyAdviserName
        })
      },
      handleSubmit () {
        let self = this
        this.$refs.form.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            return
          }

          self.$http.post('/userTrack/bindingValidTimeFail', self.formData).then(function (res) {
            if (res && res.data > 0) {
              self.$Message.success('提交成功!')
              self.$router.push('/user/userTrackList')
            }
          })
        })
      },
      allClear () {
        this.formData.bookMaterialLevel = []
      }
    },
    watch: {
    }
  }
</script>



// WEBPACK FOOTER //
// BindingValidTimeFailRecords.vue?637bda8f